import layout from 'app/store/layout';
import { handleErrors } from 'app/store/utils';

const { createToast, setLoader } = layout.actions;

export { createToast, handleErrors, setLoader };
